import { render } from "./UnifiedInventory.vue?vue&type=template&id=1add22ad&scoped=true"
import script from "./UnifiedInventory.vue?vue&type=script&lang=js"
export * from "./UnifiedInventory.vue?vue&type=script&lang=js"

import "./UnifiedInventory.vue?vue&type=style&index=0&id=1add22ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1add22ad"]])

export default __exports__